import { styled } from "@mui/material";

import { Box } from "@mui/material";

import { useBackgrounds } from "../../api/getBackgrounds";

const GalleryBox = styled(Box)(({ theme }) => ({
  position: "relative",
  display: "flex",
  paddingBottom: theme.spacing(2),
  width: "100%",
  overflow: "auto",
  gap: theme.spacing(1),
  img: {
    aspectRatio: "1 / 1",
    height: "60px",
    borderRadius: "10px",
    width: "auto",
    objectFit: "cover",
  },
  ".not_selected": {
    cursor: "pointer",
  },
  ".selected": {
    border: "1px solid red",
  },
}));

export default function BackgroundPicker({ formMethods }) {
  const { data } = useBackgrounds();

  const currentValue = formMethods.watch("backgroundImage");

  const handleSelectImage = (imgUrl) => () => {
    formMethods.setValue("backgroundImage", imgUrl, {
      shouldDirt: true,
    });
  };

  const imgClassName = (imgUrl) => {
    return currentValue === imgUrl ? "selected" : "not_selected";
  };

  return (
    <>
      <GalleryBox>
        {data?.map((img, index) => {
          return (
            <img
              alt=""
              onClick={handleSelectImage(img)}
              id="gallery_miniature_image"
              src={img}
              loading="lazy"
              className={imgClassName(img)}
            />
          );
        })}
      </GalleryBox>
    </>
  );
}
